import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function VerifyBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified) return null;

  async function resend() {
    setBusy(true);
    try {
      await api.resendVerification();
      toast.success(`Verification link sent to ${user.email}. Check your inbox.`);
    } catch (e) {
      toast.error("Could not send the link right now. Please try again shortly.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="verify-banner" data-testid="verify-banner">
      <span>Please verify your email (<b>{user.email}</b>) to secure your account. We sent you a link.</span>
      <button type="button" onClick={resend} disabled={busy} data-testid="verify-resend">
        {busy ? "Sending…" : "Resend link"}
      </button>
    </div>
  );
}
